/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import vSelect from "vue-select";
import VModal from "vue-js-modal";
import VuePrism from "vue-prism";
import carousel from 'vue-owl-carousel'
import Tabs from "vue-tabs-component";
import vueSmoothScroll from "vue-smooth-scroll";
import VueGoodTable from "vue-good-table";
import VueAutosize from "vue-autosize";
import { Money } from "v-money";
import VueTheMask from "vue-the-mask";
//import DatePicker from 'vue2-datepicker'
import Cleave from "vue-cleave-component";
import Loader from "./components/element/Loader.vue";
import notyModal from "./components/element/notyModal.vue";
import Multiselect from "vue-multiselect";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Vue from "vue";
import { LMap, LTileLayer, LMarker, LCircleMarker, LTooltip, LPopup, LPolyline } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
import ObjectToFD from 'vue-object-to-formdata';

import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css' //Vuesax styles
Vue.use(Vuesax, {
  // options here
});

import 'material-icons/iconfont/material-icons.css';
Validator.localize("es", es);

/// Init
Vue.use(VeeValidate);
Vue.use(VModal);
Vue.use(notyModal)
Vue.use(VuePrism);
Vue.use(Tabs);
Vue.use(VueGoodTable);
Vue.use(Cleave);
Vue.use(VueTheMask);
Vue.use(vueSmoothScroll);
Vue.use(VueAutosize);
Vue.use(Chartkick.use(Chart))
Vue.use(ObjectToFD);
//Vue.use(DatePicker)

//Leaflet
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-circle-marker', LCircleMarker);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-popup', LPopup);
Vue.component('l-polyline', LPolyline);

/// Componentes
Vue.component('carousel', carousel);
Vue.component('notymodal', notyModal);
Vue.component("multiselect", Multiselect);
Vue.component("v-select", vSelect);
Vue.component("money", Money);
export default {
  components: { carousel },
}
Vue.component(
  "expandableContentButton",
  require("./components/element/ExpandableContentButton.vue")
);
Vue.component(
  "fileUpload",
  require("./components/element/FileUpload.vue")
);
Vue.component("input-field", require("./components/element/InputField.vue"));
Vue.component("expandableContentCheckbox", require("./components/element/ExpandableContentCheckbox.vue"));
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.component(
  "textarea-field",
  require("./components/element/TextareaField.vue")
);
Vue.component("dropdown", require("./components/element/Dropdown.vue"));
Vue.component("buttonCard", require("./components/element/ButtonCard.vue"));
Vue.component(
  "dropdown-notification",
  require("./components/element/DropdownNotification.vue")
);
Vue.component(
  "notificaciones",
  require("./components/element/Notificaciones.vue")
);
Vue.component("notification", require("./components/element/Notification.vue"));
Vue.component("loader", Loader);
Vue.component("kTable", require("./components/element/KTable.vue"));
Vue.component("datePicker", require("./components/element/DatePicker.vue"));
Vue.component(
  "checkedListbox",
  require("./components/element/CheckedListbox.vue")
);

/// Layout
Vue.component("kp-header", require("./components/layout/Header.vue"));
Vue.component("kp-logo", require("./components/layout/Logo.vue"));
Vue.component("kp-menu", require("./components/layout/menu/MainMenu.vue"));
Vue.component("kp-submenu", require("./components/layout/menu/Submenu.vue"));
Vue.component("kp-support", require("./components/layout/Support.vue"));
Vue.component("menu-search", require("./components/layout/menu/Search.vue"));
Vue.component("kp-user", require("./components/layout/UserStatus.vue"));

//Usuarios
Vue.component(
  "crearEditarUsuario",
  require("./components/forms/mantenimiento/usuarios/CrearEditarUsuario.vue")
);

//Reportes
Vue.component(
  "logsLogin",
  require("./components/forms/reportes/LogsLogin.vue")
);
Vue.component(
  "reporteDiarioCaja",
  require("./components/forms/reportes/ReporteDiarioCaja.vue")
);
Vue.component(
  "reporteGeneralCaja",
  require("./components/forms/reportes/ReporteGeneralCaja.vue")
);
Vue.component(
  "saldoRuta",
  require("./components/forms/reportes/SaldoRuta.vue")
);

//Rutas
Vue.component(
  "ruta",
  require("./components/forms/logistica/rutas/Ruta.vue")
);

//Base por Rutas
Vue.component(
  "baseRuta",
  require("./components/forms/logistica/basesrutas/BaseRuta.vue")
);
Vue.component(
  "saldoBase",
  require("./components/forms/logistica/basesrutas/SaldoBase.vue")
);
// Movimientos de caja préstamos
Vue.component(
  "listaMovimientosPrestamos",
  require("./components/forms/prestamos/movimientos/ListaMovimientosPrestamos.vue")
);

//Vendedores
Vue.component(
  "listaVendedores",
  require("./components/forms/logistica/vendedores/ListaVendedores.vue")
);

//Préstamos
Vue.component(
  "listaPrestamos",
  require("./components/forms/prestamos/ListaPrestamos.vue")
);

//Rutas de cobros
Vue.component(
  "rutaCobros",
  require("./components/forms/prestamos/cobros/RutaCobros.vue")
);

Vue.component(
  "observacionDominical",
  require("./components/forms/prestamos/cobros/ObservacionDominical.vue")
);
Vue.component(
  "creditosAgendados",
  require("./components/forms/prestamos/cobros/CreditosAgendados.vue")
);

//Clientes
Vue.component(
  "listaClientes",
  require("./components/forms/logistica/clientes/ListaClientes.vue")
);
Vue.component(
  "cliente",
  require("./components/forms/logistica/clientes/Cliente.vue")
);
Vue.component(
  "auditoriaCliente",
  require("./components/forms/logistica/clientes/AuditoriaCliente.vue")
);
Vue.component(
  "listaClientesRuta",
  require("./components/forms/logistica/clientes/ListaClientesRuta.vue")
);

//Verificadores
Vue.component(
  "listaVerificadores",
  require("./components/forms/logistica/verificadores/ListaVerificadores.vue")
);
//Visita
Vue.component(
  "visita",
  require("./components/forms/logistica/visitas/Visita.vue")
);

//Parámetros
Vue.component(
  "Parametros",
  require("./components/forms/general/Parametros.vue")
);
Vue.component(
  "RangosCuotas",
  require("./components/forms/general/RangosCuotas.vue")
);

Vue.component(
  "Motivos",
  require("./components/forms/general/Motivos.vue")
);

Vue.component(
  "Motivo",
  require("./components/forms/general/Motivo.vue")
);

//Nómina
Vue.component(
  "RubrosNomina",
  require("./components/forms/nomina/RubrosNomina.vue")
);

Vue.component(
  "RubroNomina",
  require("./components/forms/nomina/RubroNomina.vue")
);

Vue.component(
  "IngresoRubrosNomina",
  require("./components/forms/nomina/IngresoRubrosNomina.vue")
);

Vue.component(
  "TablaIngresoRubros",
  require("./components/forms/nomina/TablaIngresoRubros.vue")
);

//Items
Vue.component(
  "Items",
  require("./components/forms/inventario/Items.vue")
);

//Bodegas
Vue.component(
  "Bodegas",
  require("./components/forms/inventario/Bodegas.vue")
);
Vue.component(
  "EgresosBodegas",
  require("./components/forms/inventario/EgresosBodegas.vue")
);
Vue.component(
  "EgresoBodega",
  require("./components/forms/inventario/EgresoBodega.vue")
);
Vue.component(
  "TablaEgresoBodega",
  require("./components/forms/inventario/TablaEgresoBodega.vue")
);
Vue.component(
  "TrEgresoBodega",
  require("./components/forms/inventario/TrEgresoBodega.vue")
);

//Pedidos
Vue.component(
  "ListaPedidos",
  require("./components/forms/logistica/pedidos/ListaPedidos.vue")
);

//Recaudaciones
Vue.component(
  "Recaudaciones",
  require("./components/forms/logistica/pedidos/Recaudaciones.vue")
);

//Reporte de cuadre de tarjetas
Vue.component(
  "ReporteCuadreTarjeta",
  require("./components/forms/logistica/pedidos/ReporteCuadreTarjeta.vue")
);

//Reporte de arqueo de ventas por mercadería
Vue.component(
  "ReporteArqueoVentas",
  require("./components/forms/logistica/pedidos/ReporteArqueoVentas.vue")
);

//Reporte de arqueo de arqueo de caja
Vue.component(
  "ReporteArqueoCaja",
  require("./components/forms/logistica/pedidos/ReporteArqueoCaja.vue")
);

//Reporte de efectividad de persona (supervisor o vendedor)
Vue.component(
  "ReporteEfectividadPersona",
  require("./components/forms/logistica/pedidos/ReporteEfectividadPersona.vue")
);

//Reporte de ventas por productos
Vue.component(
  "ReporteVentasProductos",
  require("./components/forms/logistica/pedidos/ReporteVentasProductos.vue")
);

//Kardex
Vue.component(
  "Kardex",
  require("./components/forms/inventario/Kardex.vue")
);

//Dashboard
Vue.component(
  "Dashboard",
  require("./components/forms/general/Dashboard.vue")
);

Vue.component(
  "DashboardRecaudaciones",
  require("./components/forms/general/DashboardRecaudaciones.vue")
);

Vue.component(
  "NotaDebitoCredito",
  require("./components/forms/logistica/pedidos/NotaDebitoCredito.vue")
);

//Cobranzas
Vue.component(
  "ReporteCobranza",
  require("./components/forms/logistica/pedidos/ReporteCobranza.vue")
);

Vue.component(
  "reporteValoresRecaudados",
  require("./components/forms/logistica/pedidos/ReporteValoresRecaudados.vue")
);

Vue.component(
  "reporteGeneralCartera",
  require("./components/forms/logistica/pedidos/ReporteGeneralCartera.vue")
);

// Rportes Históricos excel
Vue.component(
  "ReportesHistoricosExcel",
  require("./components/forms/general/ReportesHistoricosExcel.vue")
);

// Rportes Históricos excel
Vue.component(
  "listaGastosOficina",
  require("./components/forms/administrativo/ListaGastosOficina.vue")
);


Vue.component(
  "listaTipoGasto",
  require("./components/forms/administrativo/ListaTipoGasto.vue")
);
Vue.component(
  "TipoGasto",
  require("./components/forms/administrativo/TipoGasto.vue")
);

Vue.component(
  "consultaCierresCaja",
  require("./components/forms/administrativo/ConsultaCierresCaja.vue")
);

Vue.component(
  "cierreCaja",
  require("./components/forms/administrativo/CierreCaja.vue")
);

Vue.component(
  "recaudacionDiaria",
  require("./components/forms/logistica/pedidos/RecaudacionDiaria.vue")
);

Vue.component(
  "reporteEfectividadRecaudacion",
  require("./components/forms/logistica/pedidos/ReporteEfectividadRecaudacion.vue")
);

Vue.component(
  "reporteEfectividadProductos",
  require("./components/forms/logistica/pedidos/ReporteEfectividadProductos.vue")
);
Vue.component(
  "reporteProyeccionCartera",
  require("./components/forms/logistica/pedidos/ReporteProyeccionCartera.vue")
);
Vue.component(
  "liquidacionVentas",
  require("./components/forms/logistica/pedidos/LiquidacionVentas.vue")
);
//Nomina
Vue.component(
  "listaTiposMovimientoNomina",
  require("./components/forms/nomina/ListaTiposMovimiento.vue")
);
Vue.component(
  "listaMovimientosNomina",
  require("./components/forms/nomina/ListaMovimientos.vue")
);
Vue.component(
  "rolRecaudador",
  require("./components/forms/nomina/RolRecaudador.vue")
);
Vue.component(
  "reporteEstadoCuenta",
  require("./components/forms/nomina/ReporteEstadoCuenta.vue")
);
Vue.component(
  "consultaRolesRecaudador",
  require("./components/forms/nomina/ConsultaRolesRecaudador.vue")
);
Vue.component(
  "consultaLiquidacionesVenta",
  require("./components/forms/nomina/ConsultaLiquidacionesVenta.vue")
);
Vue.component(
  "historialVentasVendedor",
  require("./components/forms/nomina/HistorialVentasVendedor.vue")
);
Vue.component(
  "informeComisiones",
  require("./components/forms/nomina/InformeComisiones.vue")
);
Vue.component(
  "informeEntregaPremios",
  require("./components/forms/logistica/pedidos/InformeEntregaPremios.vue")
);
// Auditorias
Vue.component(
  "auditoria",
  require("./components/forms/auditorias/Auditoria.vue")
);

/// Mixins
Vue.mixin({
  methods: {
    route: route,
  },
});

axios.interceptors.request.use(
  function(config) {
    let id = uuid();
    let Modal = Vue.extend(Loader);
    let ModalComponent = new Modal({
      propsData: {
        name: id,
        loading: true,
      },
    }).$mount();
    app.$refs.app.appendChild(ModalComponent.$el);
    config.component = ModalComponent;
    config.id = id;
    app.$modal.show(id);
    return config;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    app.$modal.hide(response.config.id);
    return response;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

const app = new Vue({
  el: "#app",
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js